import { isSSR } from '@k2/core/util'
import { useOAuth } from 'vue-oidc'
import type { LocationQueryRaw, NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export const signInFirst =
  (loginQuery: (to: RouteLocationNormalized) => LocationQueryRaw = () => ({})): NavigationGuardWithThis<undefined> =>
  async (to: RouteLocationNormalized) => {
    if (isSSR) return true

    const { isAuthorized, checkToken } = useOAuth()

    await checkToken()

    if (isAuthorized.value) return true
    return { name: 'login', query: { returnUrl: to.fullPath, ...loginQuery(to) } } as RouteLocationRaw
  }

export const authorizedGuard = signInFirst()
